import React from 'react';
import { useAppSelector } from 'hooks';
import classNames from 'classnames';
import tinycolor from 'tinycolor2';

import { selectCareQualificationLevels } from '~appointments/selectors/careQualificationLevels';

interface Props {
  qualifications: string[];
  isCondensed?: boolean;
  isWrapped?: boolean;
}

const WorkerQualifications: React.FC<Props> = ({ qualifications = [], isCondensed = false, isWrapped = true }) => {
  const qualificationLevels = useAppSelector(selectCareQualificationLevels);

  const renderQualification = (isCondensed: boolean, qualification: any, index: number) => {
    const { id, name, colour, appt_match } = qualification;
    // Only render qualifications that are required for appointment matching
    if (!appt_match) return null;

    const backgroundColor = colour.length > 0 ? colour : 'lightgrey';
    const iconName = isCondensed ? name[0] : name;
    const iconClass = classNames({
      'qualification-icon': isCondensed,
      'qualification-pill': !isCondensed,
    });

    return (
      <div
        key={`qualification-${id}-${index}`}
        className={iconClass}
        style={{ backgroundColor, color: tinycolor(backgroundColor).isDark() ? 'white' : 'black' }}
        title={name}
      >
        {iconName}
      </div>
    );
  };

  const containerClass = classNames('qualification-icons-container', {
    'flex-wrap': isWrapped,
    'gap-1': isWrapped,
    'd-flex': isWrapped,
  });

  return (
    <div className={containerClass}>
      {qualifications
        ?.map((qId, index) => {
          const qualification = qualificationLevels.find(({ id }) => id === parseInt(qId));
          if (!qualification) return false;

          return renderQualification(isCondensed, qualification, index);
        })
        .filter(Boolean)}
    </div>
  );
};

export default WorkerQualifications;
